import { MediaGuideWithSubtitles } from '@/utils/media/types';
import { queryClient, queryKeys } from '@rhg/libs/react-query';

/**
 * Guide fields that change on discrete events (favorite, rating, start, complete). `progress` is
 * excluded because it changes on every playback tick, too often to write on every update.
 */
export type CachedGuideFields = Partial<
    Pick<
        MediaGuideWithSubtitles,
        'favorite' | 'favoritedAt' | 'rating' | 'completed' | 'lastPlayedAt'
    >
>;

/**
 * Invalidates the multi-guide guides queries (e.g. a playlist chunk) that contain `guideId` so
 * they rebuild from the per-guide entries. The rebuild only requests guides whose per-guide entry
 * is missing, stale or invalidated (`checkQueryCache`), so per-guide entries are left valid to
 * keep it a cache read, and batches without the guide are left alone.
 */
export function invalidateMultiGuideQueries(
    { circleId, guideId }: { circleId: number; guideId: string },
    _queryClient = queryClient
) {
    return _queryClient.invalidateQueries({
        queryKey: [queryKeys.guides, circleId, { [guideId]: guideId }],
        // The partial key also matches the single-guide entry, which must stay valid.
        predicate: ({ queryKey }) =>
            Object.keys(queryKey[2] as Record<string, string>).length !== 1,
    });
}
